<div class='ili-panel file_upload_panel'>
  <div class="input-group input-group-sm file_upload_content">
  <input type="text" [(ngModel)]="block.data.url" placeholder="Enter the url" class="form-control"></div>
  <div class="row file_upload_wrapper">
    <input style="cursor: pointer;" type="file">
    <span class="button">Browse files</span>
  </div>
</div>
